<template>
    <div class="main">
        <div class="notice">上传的信息仅用于授信审核，我们将为您严格</div>

        <div class="content">
            <div class="title">人脸识别</div>
            <div class="desc">保持前置摄像头清洁并且无遮挡</div>
            <div class="img" @click="auth">
                <img src="@/assets/img/vip/face.png" style="width: 100%;height: 100%;">
            </div>
            <div class="txt">点击完成<span style="color: #1D6FFE;">人脸识别</span></div>
        </div>
        <!--<div class="xy">
            <div v-if="selected" class="img"><img src="@/assets/img/vip/selected.png" style="width: 100%;height: 100%;"
                                                  @click="selected=!selected"></div>
            <div v-else class="img"><img src="@/assets/img/vip/no_select.png" style="width: 100%;height: 100%;"
                                         @click="selected=!selected"></div>
            申请即代表阅读并同意<span style="color: #3B72FF;">《个人信息授权书》</span>
        </div>-->
        <div>
            <div class="btn" @click="auth"
            ><span>立即认证</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "shFaceAuth",
        data() {
            return {
                selected: true
            }
        }, created() {
            this.util.title("人脸识别");
        }, mounted() {
            window.faceAuthSuccess = this.faceAuthSuccess;
        }, methods: {
            auth() {
                if (!this.selected) {
                    this.util.toast({msg: '请先勾选协议'});
                    return;
                }
                console.log("调用原生的人脸认证功能")
                this.util.toSdkAuth(27, 0);
            }, faceAuthSuccess() {
                this.$get("/app/v1.0/memeber/isMember")
                    .then((res) => {
                        if (res.code == 200) {
                            var data = res.data;
                            if (data) {
                                this.$router.push({
                                    path: "/afterLoan/newApplySuccess",
                                    query: {
                                        status: 1
                                    },
                                });
                            } else {
                                this.$get("/app/api/v1/showxin/getTcProductInfo")
                                    .then((res) => {
                                        var e = res;
                                        if (e.code == 200) {
                                            var tcApiProductId = e.data.tcApiProductId;
                                            this.$router.push({
                                                path: "/vip/choicePackage",
                                                query: {
                                                    productId: tcApiProductId,
                                                    scenceCode: 4,
                                                    webRefresh: 1
                                                },
                                            });
                                        } else {  //如果接口报错,搞个默认产品
                                            this.$router.push({
                                                path: "/vip/choicePackage",
                                                query: {
                                                    productId: 366,
                                                    scenceCode: 4,
                                                    webRefresh: 1
                                                },
                                            });
                                        }
                                    })
                                    .catch((error) => {

                                    });
                            }
                        } else {
                            this.util.toast({msg: res.message})
                        }
                    })
                    .catch((error) => {
                    });
            }
        }
    }
</script>

<style scoped>
    .main {
        background: #F7F7F7;
    }

    .notice {
        font-family: PingFangSC-Regular, PingFang SC;
        padding: 0.12rem 0 0.1rem 0;
        font-size: 0.14rem;
        font-weight: 400;
        color: #1D6FFE;
        background: #e6ebff;
        text-align: center;
    }

    .content {
        width: 100%;
        background: #FFFFFF;
    }

    .content .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #363636;
        padding: 0.2rem 0rem 0.05rem 0.1rem;
    }

    .content .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-left: 0.1rem;
    }

    .content .img {
        width: 140px;
        height: 92px;
        margin: 0rem auto;
        margin-top: 0.2rem;
    }

    .content .txt {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2F2F2F;
        text-align: center;
        margin-top: 0.1rem;
        padding-bottom: 0.2rem;
    }

    .btn {
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
        color: #fff;
        border-radius: 0.25rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.17rem;
        text-align: center;
        line-height: 0.5rem;
        width: 95%;
        margin: 0 auto;
        margin-bottom: 0.1rem;
    }

    .btn span {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }


    .xy {
        display: flex;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .xy .img {
        width: 0.12rem;
        height: 0.12rem;
        margin-right: 4px;
        margin-top: 1px;
    }


</style>
